import {authHeader, router} from '../backend'

export const userService = {
  login,
  logout,
  getAll,
  getAlarm,
  readAlarm
}

function login (userId, userPw, staySignedIn) {
  let requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    cache: 'no-cache',
    body: JSON.stringify({ userId, userPw, staySignedIn })
  }

  return fetch(`${process.env.BASE_API}/auth/login`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          localStorage.setItem('user', JSON.stringify(user.data))
          if (staySignedIn === true) {
            let date = new Date()
            date.setTime(date.getTime() + 7 * 60 * 60 * 24 * 1000)
            document.cookie = 'aplToken=' + JSON.stringify(user.data) + ';expires=' + date.toUTCString() + ';path=/'
          }
        } catch (error) {
          alert('지원하지 않는 브라우저 입니다.')
        }
      }
      return user
    })
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('sideMenu')
  localStorage.removeItem('mainBoard')
  localStorage.removeItem('currentCcode')
  localStorage.removeItem('currentLocationId')

  let date = new Date()
  document.cookie = 'aplToken= ; expires=' + date.toUTCString() + '; path=/'
}

function getAll () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/auth/info?` + Date.now(), requestOptions).then(handleResponse)
}

function getAlarm () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/auth/alarm?` + Date.now(), requestOptions).then(handleResponse)
}

function readAlarm (alarmId) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/auth/alarm/${alarmId}?` + Date.now(), requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    let data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        router.push('/login')
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    } else if (data.statusCode !== 200) {
      if (data.statusCode === 201) {
        localStorage.removeItem('user')
        router.push('/')
      } else if (data.statusCode === 202) {
        alert('아이디와 비밀번호를 확인해주세요.')
      } else if (data.statusCode === 401) {
        // auto logout if 401 response returned from api
        logout()
        router.push('/login')
      }
      router.push('/login')
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/router/userRouter.js